<template>
    <ProfessionInterested />
  </template>
  
  <script>
  import ProfessionInterested from '@/components/admin/recommendations/ProfessionInterested.vue'
  
  export default {
    name: 'InterestedProfession',
    components: { ProfessionInterested }
  }
  </script>
  
  <style scoped>
  
  </style>
  